import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Logger = /*#__PURE__*/function () {
  function Logger(namespace) {
    _classCallCheck(this, Logger);

    this._namespace = namespace;
  }

  _createClass(Logger, [{
    key: "error",
    value: function error() {
      var _console;

      for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
        params[_key] = arguments[_key];
      }

      (_console = console).error.apply(_console, [this._namespace].concat(params));
    }
  }, {
    key: "warn",
    value: function warn() {
      var _console2;

      for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        params[_key2] = arguments[_key2];
      }

      (_console2 = console).warn.apply(_console2, [this._namespace].concat(params));
    }
  }, {
    key: "info",
    value: function info() {
      var _console3;

      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        params[_key3] = arguments[_key3];
      }

      (_console3 = console).info.apply(_console3, [this._namespace].concat(params));
    }
  }, {
    key: "debug",
    value: function debug() {
      var _console4;

      for (var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        params[_key4] = arguments[_key4];
      }

      (_console4 = console).debug.apply(_console4, [this._namespace].concat(params));
    }
  }, {
    key: "trace",
    value: function trace() {
      var _console5;

      for (var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        params[_key5] = arguments[_key5];
      }

      (_console5 = console).trace.apply(_console5, [this._namespace].concat(params));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return Logger;
}();

export { Logger as default };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Logger, "Logger", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/services/Logger.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();